import { CheckoutReturnType } from './../../constants/checkout-return-type';
import { ICreatePaymentResponse } from '@legalzoom/business-formation-sdk';
import { ICreateCrossSellOrderResponse, IGetOrderContactResponse, IUpdateProcessingOrderResponse, IProcessingOrderQueueResponse } from '@legalzoom/order-sdk';
import { GetCartBalanceByCartIdResponse, IUserCart } from '@legalzoom/cart-sdk';
import { Cart, Payment } from '@legalzoom/sdk-checkout';
export interface AppState {
  processId: number;
  accessToken: string;
  sessionId: string;
  customerId: number;
  loginEmail: string;
  questionnaireId: number;
  orderId: number;
  cartId: number;
  processingOrderId: number;
  isQuestionnaireComplete: boolean;
  currentView: string;
  amount: number;
  paymentProfileId: number;
  paymentGateway: string;
  getCartBalanceByCartIdResponse: GetCartBalanceByCartIdResponse;
  gSuiteCrossSellOrderResponse: ICreateCrossSellOrderResponse;
  getOrderContactResponse: IGetOrderContactResponse;
  gSuiteCrossSellPaymentResponse: ICreatePaymentResponse;
  updateProcessingOrderResponse: IUpdateProcessingOrderResponse;
  expressOrderProcessType: CheckoutReturnType;
  tmsCrossSellOrderResponse: ICreateCrossSellOrderResponse;
  lwtCrossSellOrderResponse: ICreateCrossSellOrderResponse;
  tmsCrossSellPaymentResponse: ICreatePaymentResponse;
  lwtCrossSellPaymentResponse: ICreatePaymentResponse;
  createProcessingOrderQueue: IProcessingOrderQueueResponse;
  isGuestConvertedOnCheckout: boolean;
  firstName: string;
  lastName: string;
  cart: IUserCart;
  payment: Payment;
}
export function createAppState({
  processId = null,
  accessToken = null,
  sessionId = null,
  customerId = null,
  loginEmail = null,
  questionnaireId = 27,
  orderId = null,
  cartId = null,
  processingOrderId = null,
  isQuestionnaireComplete = null,
  currentView = null,
  amount = null,
  paymentProfileId = null,
  paymentGateway = null,
  getCartBalanceByCartIdResponse = null,
  gSuiteCrossSellOrderResponse = null,
  getOrderContactResponse = null,
  gSuiteCrossSellPaymentResponse = null,
  updateProcessingOrderResponse = null,
  expressOrderProcessType = null,
  tmsCrossSellOrderResponse = null,
  lwtCrossSellOrderResponse = null,
  tmsCrossSellPaymentResponse = null,
  lwtCrossSellPaymentResponse = null,
  createProcessingOrderQueue = null,
  isGuestConvertedOnCheckout = false,
  firstName = null,
  lastName = null,
  cart = null,
  payment = null
}: Partial<AppState>) {
  return {
    processId,
    accessToken,
    sessionId,
    customerId,
    loginEmail,
    cartId,
    processingOrderId,
    questionnaireId,
    orderId,
    isQuestionnaireComplete,
    currentView,
    amount,
    paymentProfileId,
    paymentGateway,
    getCartBalanceByCartIdResponse,
    gSuiteCrossSellOrderResponse,
    getOrderContactResponse,
    gSuiteCrossSellPaymentResponse,
    updateProcessingOrderResponse,
    expressOrderProcessType,
    tmsCrossSellOrderResponse,
    lwtCrossSellOrderResponse,
    tmsCrossSellPaymentResponse,
    lwtCrossSellPaymentResponse,
    createProcessingOrderQueue,
    isGuestConvertedOnCheckout,
    firstName,
    lastName,
    cart,
    payment
  };
}
